<template>
    <div style="padding-top: 1rem">
        <!--        <navTitle :title="$router.app._route.query.ti?$router.app._route.query.ti:'Confirm deposit details'" :ask="true"-->
        <navTitle :title="$router.app._route.query.ti?$router.app._route.query.ti:'Confirm deposit details'"></navTitle>
        <div class="list">
            <div class="title">Mohon verifikasi informasinya</div>
            <div class="li">
                <div class="info">Gunakan Tron Wallet untuk mengirim uang ke salah satu akun berikut</div>
                <div class="address">
                    <div v-for="(v,k) in list" :key="k">
                        <div class="address-info" @click="getRadioVal(v)">
                            <label class="check">
                                <svg v-if="channel===v" t="1662600739499" class="icon" viewBox="0 0 1024 1024"
                                     version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" p-id="2573" width="72" height="72">
                                    <path d="M512 85.333333C277.333333 85.333333 85.333333 277.333333 85.333333 512s192 426.666667 426.666667 426.666667 426.666667-192 426.666667-426.666667S746.666667 85.333333 512 85.333333z m230.4 324.266667l-256 256c-12.8 12.8-34.133333 12.8-46.933333 0h4.266666c-4.266667 0-12.8-4.266667-17.066666-8.533333l-140.8-140.8c-12.8-12.8-12.8-34.133333 0-51.2 12.8-12.8 34.133333-12.8 51.2 0l128 128 234.666666-234.666667c12.8-12.8 34.133333-12.8 46.933334 0l4.266666 4.266667c4.266667 12.8 4.266667 34.133333-8.533333 46.933333z"
                                          p-id="2574" fill="#00c3f9"></path>
                                </svg>
                                <svg v-else t="1662600718225" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" p-id="2370" width="72" height="72">
                                    <path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128c-211.744443 0-384 172.255557-384 384s172.255557 384 384 384 384-172.255557 384-384S723.744443 128 512 128z"
                                          p-id="2371" fill="#e6e6e6"></path>
                                </svg>
                            </label>
                            <label class="our-address">
                                Alamat Tron kami{{k+1}}:
                            </label>
                            <label class="address-detail">
                                {{v}}
                                <svg @click="copy(v)" t="1662626252530" class="icon" viewBox="0 0 1024 1024"
                                     version="1.1"
                                     xmlns="http://www.w3.org/2000/svg" p-id="2429" width="72" height="72">
                                    <path d="M760.904094 169.491931H245.929762v648.654306h-85.090888V93.039103h564.573192v54.647725h93.069095V0H67.759781v911.185339h178.159983v112.584713h734.155102V381.874227L760.904094 169.491931z m-24.904406 105.446315l128.891049 124.891948-128.891049 0.009998V274.938246zM338.998858 930.740947V262.521035h303.931734v230.35826l244.085176-0.019996v437.881648H338.998858z"
                                          p-id="2430" fill="#00c3f9"></path>
                                </svg>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="amount">
                    <label class="amount-title">Isi ulang jumlah</label>
                    <label class="query-amount">{{trx_price}}<i> TRX</i></label>
                </div>
                <div class="wallet">
                    <div class="wallet-title">Transactions Hash:</div>
                    <input class="wallet-address" v-model="hash" placeholder="Transactions Hash"/>
                    <label class="teach">Transactions Hash Dimana?<b class="click-txt" @click="lookHere"> Klik untuk
                        melihat</b></label>
                </div>
                <button class="pay-btn bg-color-blue" @click="recharge">Konfirmasi isi ulang</button>
                <div class="waring-tip">* Alamat Tron yang dipilih tidak sesuai dengan Transactions Hash, yang akan menyebabkan verifikasi deposit gagal. Silakan periksa alamat Tron deposit</div>
            </div>
        </div>
        <div v-if="hash_here">
            <img class="hash-img" src="https://api.im2017.com/uploads/store/comment/hash.png">
        </div>
    </div>
</template>
<script>
    import {getSysTronAddress, recharge_apply_trx, DebounceBy} from "../../api/user"
    import navTitle from "@components/navTitle"

    export default {
        name: "Recharge",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                channel: '',
                price: 0,
                trx_price: 0,
                list: [],
                hash: '',
                hash_here: false,
            };
        },
        mounted: function () {
            this.init()
        },
        methods: {
            getRadioVal(v) {
                this.channel = v
            },
            copy(value) {
                let oInput = document.createElement("input");
                oInput.value = value;
                document.body.appendChild(oInput)
                oInput.select()
                if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                    if (!document.execCommand("Copy")) {
                        oInput.setSelectionRange(0, oInput.value.length)
                    }
                }
                document.execCommand("Copy")
                document.body.removeChild(oInput)
                this.$dialog.success("Salin berhasil")
                return new Promise((resolve, reject) => {
                    if (document.execCommand("Copy")) {
                        resolve(value)
                    } else {
                        reject(value)
                    }
                })
            },
            init() {
                this.trx_price = this.$route.query.money_trx
                this.price = this.$route.query.amount
                let that = this
                getSysTronAddress().then(res => {
                    that.list = res.data
                    that.channel = that.list[0]
                })
            },
            recharge: DebounceBy(function () {
                let that = this, price = Number(this.price);
                if (price === 0) {
                    return that.$dialog.toast({mes: "Please enter amount to top up"});
                } else if (price < 20000) {
                    return that.$dialog.toast({mes: "Transfer amount minimum of 20000"});
                }
                if (that.channel === '') {
                    return that.$dialog.toast({mes: "Silakan pilih saluran"});
                }
                if (that.hash === '') {
                    return that.$dialog.toast({mes: "Transactions Hash Tidak boleh kosong"});
                }
                if (that.hash.length < 50) {
                    return that.$dialog.toast({mes: "Transactions Hash format yang salah."});
                }
                const paran = /^[a-z0-9]+$/
                if (!paran.test(that.hash)) {
                    return that.$dialog.toast({mes: "Transactions Hash format yang salah-"});
                }
                this.$dialog.confirm({
                    mes: "Alamat setoran pilihan Anda <b style='color: red'>"+that.channel+"</b>Setelah transfer berhasil, silakan salin Transactions Hash dan kirimkan untuk verifikasi.",
                    title: "Kirim aplikasi top up",
                    opts: [
                        {
                            txt: "Membatalkan",
                            color: false,
                            callback: () => {
                                return that.$dialog.toast({mes: "Dibatalkan"});
                            }
                        },
                        {
                            txt: "Konfirmasi",
                            color: "#00C3F9",
                            callback: () => {
                                this.$dialog.loading.open('loading...')
                                recharge_apply_trx({channel:that.channel,amount: price, hash: that.hash}).then(res => {
                                    this.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                    setTimeout(function () {
                                        that.$router.replace({path: '/hash-game-detail', query: {active: 3}})
                                    }, 2000)
                                }).catch(res => {
                                    this.$dialog.loading.close();
                                    that.$dialog.toast({mes: res.msg})
                                    if (res.msg === 'Tolong ikat dompet Tron dulu') {
                                        setTimeout(function () {
                                            that.$router.replace({path: '/hash-game-detail', query: {active: 2}})
                                        }, 2000)
                                    }
                                })
                            }
                        }
                    ]
                })
            }, 3000),
            lookHere() {
                this.hash_here = !this.hash_here
            }
        }
    };
</script>
<style scoped>
    .check {
        display: block;
        float: left;
        margin-top: 1px;
        padding-right: 2px;
    }

    .list {
        margin-top: .5rem;
        background: #fff;
    }

    .title {
        width: 90%;
        text-align: center;
        border-bottom: 2px solid #00c3f9;
        padding: .3rem 1%;
        margin-left: 4%;
    }

    .li {
        margin-top: .2rem;
        padding: .3rem 4%;
    }

    .info {
        color: red
    }

    .amount {
        font-size: .5rem;
        background: #fff;
        width: 100%;
        padding: .4rem 1%;
        color: darkgrey;
    }

    .address-info {
        background: #fff;
        width: 100%;
        padding: .2rem 0;
        color: #333333;
        margin-top: .3rem;
    }

    .address {
        margin-top: .1rem;
    }

    .query-amount, .address-detail {
        float: right
    }

    .our-address {
        font-size: 10px;
    }

    .address-detail {
        margin-top: 4px;
        font-size: 12px;
    }

    .query-amount i {
        font-size: .4rem;
    }

    .bg-color-blue {
        color: #fff;
        margin: .3rem 2%;
        width: 96%;
        text-align: center;
        font-size: .5rem;
        padding: .1rem 0;
        border-radius: .1rem;
    }

    .wallet {
        width: 100%;
        padding: .1rem 2px;
        text-align: center;
    }

    .wallet-title {
        padding: .1rem 2px;
        text-align: left;
    }

    .wallet-address {
        width: 100%;
        size: 1rem;
        padding: .2rem;
        border-radius: .1rem;
        border: 2px solid #ddd;
    }

    .teach {
        font-size: .1rem;
        float: right;
        padding: .1rem;
        color: #ddd;
    }

    .click-txt {
        color: #00c3f9
    }

    .waring-tip{
        font-weight: bold;
        padding: .1rem;
        color: red;
    }

    .hash-img {
        width: 100%;
        padding: .1rem;
    }
</style>